<header class="site_header" [class.scrolled]="isScrolled">
  <div class="conta_iner">
    <button (click)="toggleClass()" class="responsive_menu" [ngClass]="{ active: isActive }">
      <i class="fa fa-solid fa-bars"></i>
    </button>

    <a class="site_logo" routerLink="/">
      <figure style="width:100%">
        <img [src]="assetsConst.logo" alt="Logo" loading="lazy" width="65" height="50" />
      </figure>
    </a>
    <ul class="menu_list" [ngClass]="{ active: isActive }">

      <li class="dropdown_lt" [class.open]="isTravelOpen">
        <a (click)="toggleTravelDropdown()">
          {{ 'Travel' | translate }}
          <mat-icon>
            {{ isTravelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </a>

        <ul *ngIf="isTravelOpen">
          <li><a routerLink="/travel-packages" style="padding: 0 !important;" (click)="closeMenu()">{{ 'Travel Packages' | translate }}</a>
          </li>
          
          @for (country of countriesList; track country.name) {
          <li style="text-align: center;">
            <a [routerLink]="['/travel-details', country.name]"
              style="cursor: pointer; padding: 0 !important; text-decoration: none; color: inherit;"  (click)="closeMenu()">
              {{ selectedLanguage === 'ar' ? country.name_ar : country.name }}
            </a>
          </li>
          }

          <li><a routerLink="/airport-fast-track" style="padding: 0 !important;" (click)="closeMenu()">{{ 'Airport Fast Track' | translate
              }}</a></li>
          <li><a routerLink="/private-aviation" style="padding: 0!important ;"   (click)="closeMenu()">{{ 'Private Aviation' | translate }}</a>
          </li>
        </ul>
      </li>



      <li>
        <a routerLink="/support/about-us" aria-label="About Us"  (click)="closeMenu()">{{
          'AboutUs' | translate
          }}</a>
      </li>
      <li>
        <a routerLink="/ourStories" aria-label="Our Strories"  (click)="closeMenu()">{{
          'OurStories' | translate
          }}</a>
      </li>
      <li class="dropdown_lt" [class.open]="conciergeDropdownOpen">
        <a (click)="toggleConciergeDropdown()" aria-label="Concierge" >
          {{ 'Concierge' | translate }}
          <mat-icon>
            {{ conciergeDropdownOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </a>

        <ul *ngIf="conciergeDropdownOpen">
          <li>
            <a routerLink="/support/Concierge" aria-label="Concierge Info" (click)="closeMenu()">
              {{ 'Concierge Info' | translate }}
            </a>
          </li>
          <li *ngIf="!isLoggedIn || (isLoggedIn && !membershipStatus)">
            <a aria-label="XL Membership Tiers" (click)="getmembership()">
              {{ 'XL Membership Tiers' | translate }}
            </a>
          </li>
          <li *ngIf="isLoggedIn && membershipStatus">
            <a aria-label="Become a Member" (click)="gotobecomemember()">
              {{ 'Concierge Portal' | translate }}
            </a>
          </li>
        </ul>
      </li>
      <li class="dropdown_lt" [class.open]="experiencesDropdownOpen">
        <a (click)="toggleExperiencesDropdown()" aria-label="Experiences">
          {{ 'Experiences' | translate }}
          <mat-icon>
            {{ experiencesDropdownOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </a>

        <ul *ngIf="experiencesDropdownOpen">
          @for (item of categoryArray; track $index) {
          <li>
            <a routerLink="/experiences/search" [queryParams]="{
            categoryid: item._id,
            slug: item.categorySlug
          }" aria-label="Categories"  (click)="closeMenu()">
              {{ item?.name | languageConversion: [item, selectedLanguage, 'name'] }}
            </a>
          </li>
          }
          <li><a routerLink="/custom-packages" (click)="closeMenu()">Custom Package</a></li>
        </ul>
      </li>



    </ul>

    <div class="menu_items">
      @if (!profileDetails) {
      <button class="btn sm btn_white br" (click)="openLoginModal()" aria-label="Login">
        {{ 'LoginSignUp' | translate }}
      </button>
      }

      <a class="icon_btn" [routerLink]="'/cart'" [queryParams]="{ purchaseType: purchaseTypes.cart }" aria-label="Cart">
        <span class="fav_icon">
          <mat-icon>shopping_cart</mat-icon>
        </span>
        @if (totalCartCount && totalCartCount > 0) {
        <p>{{ totalCartCount }}</p>
        }
      </a>

      <a class="icon_btn" routerLink="/wishlist/list/1" aria-label="wishlist">
        <span class="fav_icon">
          <mat-icon>favorite</mat-icon>
        </span>
      </a>
      <!-- Currency Button Trigger -->
      <button class="language_btn" mat-button [matMenuTriggerFor]="currencyMenu" aria-label="Currency">
        <ng-container *ngIf="currencyService.getCurrentCurrency() === 'AED'; else showCurrencyText">
          <img [src]="assetsConst.dirham_icon" alt="AED" width="24"
            style="vertical-align: middle; margin-right: 4px;" />
        </ng-container>
        <ng-template #showCurrencyText>
          {{ currencyService.getCurrentCurrency() }}
        </ng-template>
      </button>


      <!-- Currency Dropdown Menu -->
      <mat-menu #currencyMenu="matMenu" class="header_dropbox">
        <button mat-menu-item (click)="setCurrency('AED')">
          <img src={{assetsConst.dirham}} width="20" alt="">
        </button>
        <button mat-menu-item (click)="setCurrency('USD')">USD</button>
        <!-- <button mat-menu-item (click)="setCurrency('EUR')">EUR</button> -->
      </mat-menu>
      <!-- <button class="language_btn" mat-button [matMenuTriggerFor]="languageMenu" aria-label="Language">
        <img src="{{ assetsConst.language_icon }}" alt="Icon" />
        {{ selectedLanguage }}
      </button>

      <mat-menu #languageMenu="matMenu" class="header_dropbox">
        <button (click)="onLangSelect('en')" mat-menu-item>
          {{ 'English' | translate }} {{ '(EN)' | translate }}
        </button>

        <button (click)="onLangSelect('ar')" mat-menu-item>
          {{ 'Arabic' | translate }} {{ '(AR)' | translate }}
        </button>
      </mat-menu> -->

      @if (profileDetails) {
      <button class="user_btn" mat-button [matMenuTriggerFor]="userMenu" aria-label="Profile">
        <figure>
          <img [src]="
                profileDetails.image ? profileDetails.image : assetsConst.logo2
              " alt="Image" />
        </figure>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu" xPosition="before" class="header_dropbox user_dropbox">
        <button mat-menu-item routerLink="/my-account" aria-label="My Account">
          {{ 'MyAccount' | translate }}
        </button>

        <button mat-menu-item routerLink="/change-password" aria-label="Change Password">
          {{ 'ChangePassword' | translate }}
        </button>

        <button mat-menu-item routerLink="/notification-list" aria-label="Notification">
          {{ 'Notifications' | translate }}
        </button>
        <button mat-menu-item routerLink="/wishlist/list/1" aria-label="wishlist">
          {{ 'Wishlist' | translate }}
        </button>
        <button mat-menu-item [routerLink]="'/cart'" [queryParams]="{ purchaseType: purchaseTypes.cart }"
          aria-label="Cart">
          {{ 'Cart' | translate }}
        </button>
        <!-- <button mat-menu-item routerLink="/subscriptions">
            {{ 'Memberships' | translate }}
          </button> -->

        <button mat-menu-item routerLink="/my-bookings" aria-label="My Bookings">
          {{ 'MyBookings' | translate }}
        </button>

        <button mat-menu-item [routerLink]="'/experiences/search'" [queryParams]="{
              packageCategory: packageCategoryTypes.CustomPackage
            }" aria-label="My Packages">
          {{ 'MyPackages' | translate }}
        </button>
        <button mat-menu-item routerLink="/contact-us" aria-label="Connect with Us">
          {{ 'Connectwithus' | translate }}
        </button>

        <button mat-menu-item (click)="logout()" aria-label="Logout">
          {{ 'Logout' | translate }}
        </button>

        <hr />
        <button class="btn btn_primary" mat-menu-item routerLink="/" [queryParams]="{
              section: 'categories'
            }" aria-label="Continue Shopping">
          {{ 'ContinueShopping' | translate }}
        </button>
      </mat-menu>
      }
    </div>
  </div>
</header>